export { default } from "./UserDetails";
